
import Vue, {PropType} from "vue";
import {AlertDiscountDto} from "../dto/AlertDiscountDto";

export default Vue.extend ({
    name: "AlertDiscount",
    props: {
        dto: {
            type: Object as PropType<AlertDiscountDto>,
            required: true
        }
    },
    computed: {
        additionalClass: function() {
            if (this.dto.showAsNormalText) {
                return "ob1-normal-text"
            } else return ""
        },
        showDescription: function() {
            return this.dto.description?.length > 0
        },
        showLink: function() {
            return this.dto.link?.length > 0
        }
    }
})

